import { fetchRecentCourses } from "features/Home/services/homePageDataService";
import { call, put, takeLatest } from "redux-saga/effects";
import { err, got, req } from "./homeRecentCoursesSlice";
import { mapToHistoryItems } from "features/Account/services/historyResultsMapperService";
import { type HistoryItem } from "features/Account/types";

export function* fetchHomeRecentCourses() {
  try {
    const items: HistoryItem[] = yield call(fetchRecentCourses);
    const limitedItems = mapToHistoryItems(items.slice(0, 9));
    yield put(got(limitedItems));
  } catch (error: any) {
    yield put(err(error?.message));
  }
}

export function* homeRecentCoursesWatcher() {
  yield takeLatest(req.type, fetchHomeRecentCourses);
}
